import script from "./WrongWordReview.vue?vue&type=script&setup=true&lang=js"
export * from "./WrongWordReview.vue?vue&type=script&setup=true&lang=js"

import "./WrongWordReview.vue?vue&type=style&index=0&id=4e5661bb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e5661bb"]])

export default __exports__